<div class="container">
    <div class="row g-3" *ngIf="rateItems">
        <div class="col-12">
            <h3>อัตราจำนวนเงินเปลี่ยนเป็นแต้ม</h3>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-5 col-12">
            <p>จำนวนเงินต่อแต้มคะแนน</p>
            <input type="number" class="form-control" [(ngModel)]="rateItems.Amount">
        </div>
        <div class="col-xl-1 col-lg-1 col-md-1 col-12 text-center">
            <span class="material-symbols-outlined mt-5 d-none d-lg-block d-xl-block d-md-block">
                arrow_forward
            </span>
            <span class="material-symbols-outlined mt-3 d-block d-lg-none d-xl-none d-md-none">
                south
            </span>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-5 col-12">
            <p>แต้มคะแนนที่ได้รับ</p>
            <input type="number" class="form-control" [(ngModel)]="rateItems.Point">
        </div>
        <div class="col-12">
            <button class="btn btn-cancel me-3" (click)="resetValue()">คืนค่าเดิม</button>
            <button class="btn btn-primary" (click)="putRate()">บันทึก</button>
        </div>
    </div>
</div>